if (!customElements.get('clay-stick-guide')) {
  class ClayStickGuide extends HTMLElement {
    connectedCallback() {
      this.handleToggle = this.handleToggle.bind(this);
      this.addEventListener('toggle', this.handleToggle, true);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.handleToggle, true);
    }

    handleToggle(event) {
      const activeItem = event.target;

      if (
        !this.hasAttribute('data-single-open') ||
        !(activeItem instanceof HTMLDetailsElement) ||
        !activeItem.matches('[data-clay-faq-item]') ||
        !activeItem.open
      ) {
        return;
      }

      this.querySelectorAll('[data-clay-faq-item][open]').forEach((item) => {
        if (item !== activeItem) item.open = false;
      });
    }
  }

  customElements.define('clay-stick-guide', ClayStickGuide);
}
